import {Injectable} from "@angular/core";
import {ObservableBackendService} from "./observableBackend.service";
import {Observable} from "rxjs/Rx";
import {MailTemplateProperty} from "../domain/mailTemplateProperty";

/**
 * .
 * Created by jlado on 8/2/18.
 */
@Injectable()
export class MailTemplateTagService {

    constructor(private backendService: ObservableBackendService) {
    }

    public getMailTemplateTags(): Observable<MailTemplateProperty[]> {
        return this.backendService.get("mailTemplateTags", null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/mailTemplateTag.service.ts
 **/